// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"9015b34d","713":"a8f22301"}[chunkId] + ".chunk.js";
};